export default "__VITE_ASSET__DAFPgnLF__"